import React from "react";
import { Link } from "react-router-dom";
import { t } from "../contexts/translations";

export default function PaiementSecurise({ language = 'fr' }) {
  const logos = [
    { src: "/cmi/logo_cmi.png", alt: "CMI" },
    { src: "/cmi/tn_verified_by_visa.png", alt: "Verified by Visa" },
    { src: "/cmi/secure_code_logo.png", alt: "Mastercard SecureCode" },
    { src: "/cmi/MarocPay.png", alt: "Maroc Pay" },
    { src: "/cmi/AMEX.png", alt: "American Express" },
    { src: "/cmi/unionpay.png", alt: "UnionPay" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-orange-200/50 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('securePaymentTitle', language)}</h1>
        <p className="text-gray-600 mb-6">
          {t('securePaymentDesc', language)}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 items-center">
          {logos.map((l) => (
            <div key={l.alt} className="flex items-center justify-center p-4 bg-white rounded-xl border border-gray-200">
              <img src={l.src} alt={l.alt} className="max-h-14 object-contain" />
            </div>
          ))}
        </div>

        <div className="mt-8 text-sm text-gray-600">
          <p>
            {t('threeDSecure', language)}
          </p>
        </div>

        <div className="mt-8">
          <Link to="/" className="text-orange-600 hover:text-orange-500 font-medium">
            {language === 'fr' ? "← Retour à l’accueil" : "← Back to home"}
          </Link>
        </div>
      </div>
    </div>
  );
}
